<template>
  <div class="filters-container">
    <el-row :gutter="24">
      <custom-input
        v-model="filters.Codigo"
        :spanColumn="3"
        :label="'Código'"
        :settings="{
          placeholder: 'Código',
          min: 0,
          precision: 0,
          step: 0.01,
          controls: false,
        }"
      ></custom-input>
      <custom-input
        v-model.number="filters.Usuario"
        :label="'Usuario'"
        :spanColumn="4"
        :settings="{
          placeholder: 'Ingresar usuario',
        }"
      ></custom-input>
      <custom-input
        v-model.number="filters.Nombre"
        :label="'Nombre'"
        :spanColumn="4"
        :settings="{
          placeholder: 'Ingresar nombre',
        }"
      ></custom-input>
      <custom-input
        v-model.number="filters.Apellido"
        :label="'Apellido'"
        :spanColumn="4"
        :settings="{
          placeholder: 'Ingresar apellido',
        }"
      ></custom-input>
      <el-col :span="4">
        <div class="custom-label">Activo</div>
        <el-switch
          v-model="filters.Activo"
          active-text="Si"
          inactive-text="No"
          class="mb-2"
          sieze="large"
        />
      </el-col>
      <el-col
        :span="2"
        class="button-container"
      >
        <el-button
          type="primary"
          size="default"
          @click="filtrarUsuarios"
          >Filtrar</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { onBeforeMount } from 'vue';
import CustomInput from '@/shared/components/custom_input.vue';
import { storeToRefs } from 'pinia';
import { useUserStore } from '../stores/user_store.js';
const userStore = useUserStore();
const { filters } = storeToRefs(userStore);
const { emptyList, findAllUsersHTTP, setPage } = userStore;

const filtrarUsuarios = () => {
  const newFilters = {
    Codigo: filters.value.Codigo,
    Usuario: filters.value.Usuario,
    Nombre: filters.value.Nombre,
    Apellido: filters.value.Apellido,
    Activo: filters.value.Activo,
  };
  setPage(1);
  emptyList();
  findAllUsersHTTP(newFilters);
};
</script>

<style scoped>
.filters-container {
  background-color: white;
  border: 3px solid lightgray;
  padding: 20px;
}
.custom-label {
  font-weight: 700;
  color: #111;
}
.button-container {
  /* Estilo específico para el contenedor del botón */
  margin-top: auto; /* Empuja el contenido hacia abajo, ocupando la parte inferior */
}
.margin-row {
  margin-top: 1%;
}
</style>
